import React, { createContext, useContext } from 'react';
import useTabSystem from '../hooks/useTabSystem';
import { AuthContext } from './AuthContext';
import { getCharacterWorkspaceId } from '../utils/identity';

/**
 * TabContext - Global tab management context
 * 
 * Provides tab system functionality across the entire app
 */
const TabContext = createContext(null);

export function TabProvider({ children }) {
  const { user } = useContext(AuthContext) || {};
  const tabSystem = useTabSystem(getCharacterWorkspaceId(user));
  
  return (
    <TabContext.Provider value={tabSystem}>
      {children}
    </TabContext.Provider>
  );
}

export function useTabContext() {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabContext must be used within TabProvider');
  }
  return context;
}

/**
 * Safe version of useTabContext that returns null instead of throwing
 * when used outside TabProvider. Useful for components that may render
 * before TabProvider is initialized (e.g., during auth loading).
 */
export function useTabContextSafe() {
  return useContext(TabContext);
}

export default TabContext;
